export class ObjectHelper {
  public static areEqual(a: object | [] | null | undefined, b: object | [] | null | undefined): boolean {
    return JSON.stringify(a) === JSON.stringify(b)
  }

  public static clone<T>(obj: T): T {
    return obj ? (JSON.parse(JSON.stringify(obj)) as T) : obj
  }

  public static isEmpty<T extends object>(obj: T): boolean {
    return Object.keys(obj).length === 0
  }
}
